
import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
  } from 'chart.js';   

  import { Bar } from 'react-chartjs-2';
  import {color_map_score} from './colorconst'
    ChartJS.register(
      CategoryScale,
      LinearScale,
      BarElement,
      Title,
      Tooltip,
      Legend
    );


  const kleurs = ['rgba(240, 59, 10, 0.6)', 'rgba(235, 200, 26, 0.6)', 'rgba(54, 162, 235, 0.6)',
                  'rgba(134, 230, 106, 0.6)', 'rgba(65, 138, 43, 0.6)']
  const makeRepeated = (arr, repeats) =>
      Array.from({ length: repeats }, () => arr).flat();

  function roundUp(num, precision) {
    precision = Math.pow(10, precision)
    return Math.ceil(num * precision) / precision
  };

  function arrayFromObject(obj) {
    var arr = [];
    for (var i in obj) {
        arr.push(obj[i]);
    }
    return arr;
  }
  
  function GroupBy(list, fn) {
    var groups = {};
    for (var i = 0; i < list.length; i++) {
        var group = JSON.stringify(fn(list[i]));
        if (group in groups) {
            groups[group].push(list[i]);
        } else {
            groups[group] = [list[i]];
        }
    }
    return arrayFromObject(groups);
  }
  

  export const options_barchart = {
    responsive: true,
    maintainAspectRatio: true,
    animation: {
      duration: 1000,
      easing: "linear",
    },
    plugins: {
      legend: {
        display: false,
        position: 'top',
        // color:bgColors.grey_100,
        labels: {
            display:false
            // usePointStyle: true
        }
      },
    },
    scales: {
      y:
        {
          min: 0,
          max: 5,
          stepSize: 1,
        },
      }
  //   scales: {
  //     xAxes: [{
  //             display: true,
  //             scaleLabel: {
  //                 display: true,
  //                 labelString: 'season'
  //             }
  //         }],
  //     yAxes: [{
  //             display: true,
  //             ticks: {
  //                 beginAtZero: true,
  //                 steps: 5,
  //                 stepValue: 1,
  //                 max: 5
  //             }
  //         }]
  // }
  };

  export const options_grouped = {
    responsive: true,
    maintainAspectRatio: true,
    animation: {
      duration: 1000,
      easing: "linear",
    },
    plugins: {
      legend: {
        display: true,
        position: 'top',
        // color:bgColors.grey_100,
        labels: {
            display:true,
            usePointStyle: true,
            font: {
              size: 8
        },
        
      }
      },
    },
    scales: {
      y:
        {
          min: 0,
          max: 5,
          stepSize: 1,
        },
      }
  //   scales: {
  //     xAxes: [{
  //             display: true,
  //             scaleLabel: {
  //                 display: true,
  //                 labelString: 'year'
  //             }
  //         }],
  //     yAxes: [{
  //             display: true,
  //             ticks: {
  //                 beginAtZero: true,
  //                 steps: 5,
  //                 stepValue: 1,
  //                 max: 5
  //             }
  //         }]
  // },
  };
 

export function barChartData(data,label){
  let labels = []
  let data_array = []
  let color_map = []
  // let color_irrigation = []

  data.forEach((item)=> 
    {labels.push(item.season)})

  data.forEach((item)=> 
  { data_array.push(item.yield_score)})
  
  data.forEach((item) => {
    color_map.push(color_map_score(item.yield_score))
  })
  
  const barData = {
    labels,
    datasets: [
      {
        label: label,
        data: data_array,
        backgroundColor: color_map,
      },
    ],
  };
  return barData;
}

export function groupbycrop(crop_table){
  var groupedtable = GroupBy(crop_table, function(crop_table){
      return [crop_table.season, crop_table.cropname, crop_table.year];
  });
  let cropmaptable = []
  groupedtable.forEach(data => {
      let reduced = data.reduce(function(m, d){
          if(!m[d.cropname]){
            m[d.cropname] = {...d, count: 1};
            return m;
          }
          m[d.cropname].perfscore += d.perfscore;
          m[d.cropname].area += d.area;
          m[d.cropname].count += 1;
          return m;
       },{});
       var result = Object.keys(reduced).map(function(k){
          const item  = reduced[k];
          return {
              year: item.year,
              season: item.season,
              cropname: item.cropname,
              season_weight: item.season_weight,
              perfscore: item.perfscore/item.count,
              area: item.area/item.count,
          }
         
          
      })
      cropmaptable.push(result[0])
  })
  return cropmaptable
}

export function MultibarChart(crop_table){

  let croptable = []
  crop_table.forEach(row => {
      if(parseFloat(row.season_weight) > 0){
          croptable.push(row)
      }
  })
  

  let crops =  croptable.map(item => item.cropname)
  .filter((value, index, self) => self.indexOf(value) === index)

  let years = croptable.map(item => item.year)
  .filter((value, index, self) => self.indexOf(value) === index)
  years.sort()
  let barData = {
      labels: years,
      datasets: []
  }

  const length_keys = crops.length ;
  const number_of_num_color = length_keys / kleurs.length
  var num_color = makeRepeated(kleurs, roundUp(number_of_num_color, 0))
  
  crops.forEach(crop => {
      let _potdata = {
          label: crop,
          data:[],
          backgroundColor:''
      } 
      let cropindex = crops.indexOf(crop)
      _potdata.backgroundColor=num_color[cropindex]
      years.forEach(year => {
          let _score = 0
          let _area = 0
          let wtdscore = 0
          croptable.forEach(row => {
              if(row.cropname===crop && 
                  row.year === year
                  ){
                      _score += row.perfscore*parseFloat(row.area)
                      _area += parseFloat(row.area)
                  }
                else{
                  _score +=0
                  _area +=0
                }
          })
          if(_score===0 || _area===0){
              wtdscore = 0
          }
          else{
              wtdscore = _score/_area
          }
          _potdata.data.push(wtdscore)

      })
      barData.datasets.push(_potdata)
  })
 return(barData)
}

export function BarChart(props) {
  const {data} = props
  return <Bar options={options_barchart} data={data} />;
}

export function CropBarChart(props) {
  const {data} = props
  return <Bar options={options_grouped} data={data}/>;
}























